import React from 'react';
import { registerWidget } from '@okapi/core';
import { ProductCarouselWidget } from 'entries/common/widgets';
import type { ProductCarouselProps, ProductsServerData } from 'features/product/product-carousel/types';

registerWidget<ProductsServerData, ProductCarouselProps>(`${__NAME__}/product-carousel`, serverData => {
  return props => (
    <ProductCarouselWidget
      {...props}
      productsIds={serverData?.productsIds}
      rrTracking={serverData?.rrTracking}
    />
  );
});
